import { supabase } from './supabaseClient';

export async function uploadToStorage(bucket, file, pathPrefix = '', onProgress) {
  // Sanitize filename: replace spaces with underscores, remove special characters
  const sanitizedName = file.name
    .replace(/\s+/g, '_') // Replace spaces with underscores
    .replace(/[^a-zA-Z0-9._-]/g, '') // Remove special characters except dots, underscores, hyphens
    .toLowerCase(); // Convert to lowercase for consistency

  const filePath = `${pathPrefix}${Date.now()}_${sanitizedName}`;

  // For files larger than 6MB, use resumable upload as recommended by Supabase
  if (file.size > 6 * 1024 * 1024) {
    console.log(`Using resumable upload for large file: ${file.name} (${(file.size / (1024 * 1024)).toFixed(2)} MB)`);

    try {
      const { error } = await supabase.storage
        .from(bucket)
        .upload(filePath, file, {
          upsert: true,
          onUploadProgress: (progress) => {
            if (onProgress) {
              onProgress(progress.loaded, progress.total);
            }
          },
        });

      if (error) throw error;
      return filePath;
    } catch (error) {
      console.error('Resumable upload failed:', error);
      throw error;
    }
  } else {
    // Use standard upload for smaller files
    console.log(`Using standard upload for file: ${file.name} (${(file.size / (1024 * 1024)).toFixed(2)} MB)`);

    const { error } = await supabase.storage.from(bucket).upload(filePath, file, {
      upsert: true,
    });

    if (error) throw error;
    return filePath;
  }
}
